import { ControlsStore } from '../ControlsStore'

/**
 * Creates control store
 */
export function controls() {
  return new ControlsStore()
}
